import { useLayoutEffect, useState } from 'react';

export const SCREEN_WIDTH = {
  EXTRA_LARGE: 1600,
};

const getWindowSize = () => [window.innerWidth, window.innerHeight];

export const useWindowSize = () => {
  //* read the real size on first render: starting at [0, 0] made width-based
  //* layouts (e.g. Skeleton rows) render empty for the first 500ms, then jump
  const [size, setSize] = useState(getWindowSize);
  useLayoutEffect(() => {
    let resizeTo;
    const updateSize = () => {
      if (resizeTo) clearTimeout(resizeTo);
      resizeTo = setTimeout(() => {
        setSize(getWindowSize());
      }, 500);
    };
    window.addEventListener('resize', updateSize);
    return () => {
      clearTimeout(resizeTo);
      window.removeEventListener('resize', updateSize);
    };
  }, []);
  return size;
};
